(function () {
  var bar = document.getElementById('regada-sticky-atc');
  if (!bar) return;

  var mainBuyBtn = document.querySelector('.product-form__submit');
  var stickyVariantInput = document.getElementById('regada-sticky-variant-id');
  var stickyBtn = bar.querySelector('.regada-sticky-atc__btn');
  var stickyPriceEl = document.getElementById('regada-sticky-price');

  // Show/hide sticky bar when main ATC button enters/leaves viewport
  if (mainBuyBtn && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      bar.classList.toggle('regada-sticky-atc--visible', !visible);
      bar.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0 });
    io.observe(mainBuyBtn);
  }

  // Read selected variant ID from the main product form
  function getMainVariantId() {
    var input = document.querySelector('product-form input[name="id"]');
    return input ? input.value : null;
  }

  // Sync variant ID + button availability from main form
  function syncVariant() {
    var variantId = getMainVariantId();
    if (variantId && stickyVariantInput) {
      stickyVariantInput.value = variantId;
    }

    if (stickyBtn && mainBuyBtn) {
      var soldOut = mainBuyBtn.hasAttribute('disabled');
      stickyBtn.disabled = soldOut;
      stickyBtn.textContent = soldOut ? 'Sold Out' : 'Add to Cart';
    }
  }

  // Mirror the price from the main price display
  function syncPrice() {
    if (!stickyPriceEl) return;
    var priceEl = document.querySelector('.price--large .price-item--regular, .price--large .price-item--sale');
    if (priceEl) {
      stickyPriceEl.textContent = priceEl.textContent.trim();
    }
  }

  // Listen for variant changes (Dawn emits change events on product-info)
  var productInfo = document.querySelector('product-info');
  if (productInfo) {
    productInfo.addEventListener('change', function () {
      setTimeout(function () {
        syncVariant();
        syncPrice();
      }, 80);
    });
  }

  // Initial state
  syncVariant();
  syncPrice();
})();
